import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import Grid from '../../components/GridView'
import RowDetail from './RowDetail'

const query = gql`
  query {
    documents {
      id
      cod
      type
      due_date
      metadata
      customer {
        id
        cod
        name
      }
      insurer {
        id
        cod
        name
      }
    }
  }
`
const withQuery = graphql(query)

export default compose(
  withQuery,
  withProps(({ data }) => {
    console.log(data)
    return {
      columns: [
        {
          name: 'type',
          title: 'Tipo'
        },
        {
          name: 'cod',
          title: 'Código'
        },
        {
          name: 'client',
          title: 'Cliente',
          getCellValue: row =>
            (row.customer && row.customer.name) || row.metadata.cpfs.join(';')
        },
        {
          name: 'insurer',
          title: 'Seguradora',
          getCellValue: row =>
            (row.insurer && row.insurer.cod) || row.metadata.insurer
        },
        { name: 'due_date', title: 'Vencimento', sort: 'asc', type: 'date' },
        {
          name: 'id',
          label: 'editar',
          to: '/documents',
          title: ' ',
          type: 'link'
        }
      ],
      extensions: [
        { columnName: 'id', width: 75, align: 'center' },
        { columnName: 'due_date', width: 150, align: 'center' },
        { columnName: 'type', width: 100, align: 'center' },
        { columnName: 'insurer', width: 100, align: 'center' }
      ],

      loading: data.loading,
      detailComponent: RowDetail,
      rows: data.documents //filter(data.documents, doc => !doc.children) || []
    }
  })
)(Grid)
